import { Flex, Box, Text } from '@chakra-ui/react';

interface TextLinkToggleProps {
  isLink: boolean;
  onChange: (isLink: boolean) => void;
}

const toggleItemStyles = (isActive: boolean) => ({
  px: '8px',
  py: '3px',
  borderRadius: '4px',
  cursor: 'pointer' as const,
  bg: isActive ? 'rgba(58,74,87,0.25)' : '#f1f1f1',
  border: isActive ? '1px solid #3a4a57' : '1px solid transparent',
});

const TextLinkToggle = ({ isLink, onChange }: TextLinkToggleProps) => (
  <Flex gap={2} align="center">
    <Box
      {...toggleItemStyles(!isLink)}
      onClick={() => onChange(false)}
    >
      <Text
        fontSize="13px"
        color={!isLink ? '#2f343d' : '#7a7a7a'}
        whiteSpace="nowrap"
      >
        Text
      </Text>
    </Box>
    <Box
      {...toggleItemStyles(isLink)}
      onClick={() => onChange(true)}
    >
      <Text
        fontSize="13px"
        color={isLink ? '#2f343d' : '#7a7a7a'}
        whiteSpace="nowrap"
      >
        Link
      </Text>
    </Box>
  </Flex>
);

export default TextLinkToggle;
